import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const CARGO_GERENTE_DE_PROJETOS: MapaCargo = 
{
  id: 'gerente-de-projetos',
  titulo: 'Gerente de Projetos',
  setor: 'Projetos',
  secoes: [
    {
      id: 'responsabilidades',
      titulo: 'Responsabilidades',
      atividades: [
        'Gerenciamento de equipe;',
        'Gerenciamento da execução dos projetos de e-commerce;',
        'Definição do escopo do projeto de acordo com o serviço contratado;',
        'Planejamento e acompanhamento da execução de cada etapa do projeto;',
        'Suporte à atualização do projeto;',
        'Gerenciamento de pauta;',
        'Atendimento e alinhamento com cliente;',
        'Reuniões semanais com parceiros para follow-up;',
        'Treinamento de novos colaboradores;',
        'Gerenciamento de fluxos via plataforma Monday;',
        'Desenvolvimento de novos fluxos de execução;',
        'Documentação de processos;',
        'Condução de reuniões internas de status para acompanhar a evolução das demandas solicitadas,',
        'Identificação e resolução de eventuais problemas durante a implantação do projeto.',
      ],
    },
  ],
}
